import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import StudService from "@/pages/StudService";
import PuppyWaitlist from "@/pages/PuppyWaitlist";
import StudWaitlist from "@/pages/StudWaitlist";
import { Productions, OwnerUpdates } from "@/pages/Placeholders";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/stud-service" element={<StudService />} />
          <Route path="/puppy-waitlist" element={<PuppyWaitlist />} />
          <Route path="/stud-waitlist" element={<StudWaitlist />} />
          <Route path="/productions" element={<Productions />} />
          <Route path="/owner-updates" element={<OwnerUpdates />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancelled" element={<PaymentSuccess />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
